import { AvailableProvider, ExistingProvider } from "../types";

export function normalizeBrandsArray(
  brands: ExistingProvider["brands"],
): string[] {
  if (!brands || !Array.isArray(brands)) {
    return [];
  }

  return brands.map((brand) => {
    if (typeof brand === "string") {
      return brand;
    }
    if (typeof brand === "object" && brand !== null) {
      return (
        (brand as { brand?: string; id?: string }).brand ||
        (brand as { brand?: string; id?: string }).id ||
        String(brand)
      );
    }
    return String(brand);
  });
}

export function parseMccValue(
  mccValue: string | number | undefined,
): number | undefined {
  if (typeof mccValue === "string") {
    const mccNumber = Number(mccValue);
    return mccNumber && mccNumber !== 0 ? mccNumber : undefined;
  }
  if (typeof mccValue === "number") {
    return mccValue !== 0 ? mccValue : undefined;
  }
  return undefined;
}

export function sanitizeProviders(
  externalAvailableProviders?: AvailableProvider[],
): AvailableProvider[] {
  if (!externalAvailableProviders || externalAvailableProviders.length === 0) {
    return [];
  }

  return externalAvailableProviders.map((provider) => {
    let parsedSchema: AvailableProvider["schema"];
    if (provider.schema) {
      parsedSchema =
        typeof provider.schema === "string"
          ? JSON.parse(provider.schema)
          : provider.schema;
    }
    const typeFromSchema = parsedSchema?.examples?.[0]?.type || "";
    const credentialsType =
      parsedSchema?.properties?.credentials?.properties?.type?.const || "";

    return {
      id: provider.id,
      name: provider.name,
      code: provider.code || "",
      type: typeFromSchema,
      priority: provider.priority || 1,
      methods: provider.methods || ["Credit"],
      credentials: {
        type: credentialsType,
      },
      schema: parsedSchema,
      createdAt: provider.createdAt,
      modifiedAt: provider.modifiedAt,
    };
  });
}
